export default __webpack_public_path__ + "static/circle-ee421428e70c8c88bd28a12a5fc2c1c8.png";